import { TopToolbar, useTranslate } from 'react-admin'
import { Button } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'

interface RetailerPeriodListToolbarProps {
    resource: string
    handleCreateCallback: () => void
}

const RetailerPeriodListToolbar = ({
    resource,
    handleCreateCallback
}: RetailerPeriodListToolbarProps) => {
    const translate = useTranslate()

    return (
        <TopToolbar>
            <Button color="primary" variant={'outlined'} onClick={handleCreateCallback}>
                <AddIcon />
                {translate(`manager.resources.${resource}.add`)}
            </Button>
        </TopToolbar>
    )
}

export default RetailerPeriodListToolbar
